"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const styled_tools_1 = require("styled-tools");
const Input_1 = require("./Input");
exports.TextInput = styled_1.default(Input_1.Input) `
  padding: 0 4px;
  outline: none;
  ${styled_tools_1.prop('theme.fonts.axiformaRegular')};
  ${styled_tools_1.prop('theme.fontStyles.subheading')};
  background-color: white;
  height: 40px;
  border: 1px solid rgba(0, 0, 0, 0.2);

  &:hover {
    border: 1px solid rgba(0, 0, 0, 0.3);
  }

  &:focus {
    border: 1px solid rgba(0, 0, 0, 0.3);
  }
`;

//# sourceMappingURL=TextInput.js.map
